<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{initData.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位</label>
            <span class="weui-form-preview__value">{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">1-3月数量</label>
            <span class="weui-form-preview__value">{{initData.qty1}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">1-3月金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount1}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">4-6月数量</label>
            <span class="weui-form-preview__value">{{initData.qty2}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">4-6月金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount2}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">7-9月数量</label>
            <span class="weui-form-preview__value">{{initData.qty3}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">7-9月金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount3}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">10-12月数量</label>
            <span class="weui-form-preview__value">{{initData.qty4}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">10-12月金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount4}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">1-3年数量</label>
            <span class="weui-form-preview__value">{{initData.qty5}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">1-3年金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount5}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">3年以上数量</label>
            <span class="weui-form-preview__value">{{initData.qty6}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">3年以上金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount6}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>